// Global offline status banner (non-dismissible, shown at top of app)
function OfflineStatusBanner({isOnline}) {
  if (isOnline) return null;
  return (
    <div style={{background:"#1a0a00",padding:"8px 16px",display:"flex",alignItems:"center",gap:8,borderBottom:"1px solid #7c2d12"}}>
      <span style={{fontSize:13}}>📵</span>
      <div style={{fontSize:12,color:"#fb923c"}}>You're offline. Data shown may be outdated.</div>
    </div>
  );
}

export default OfflineStatusBanner;
